import { createSlice } from '@reduxjs/toolkit'

export const initialTicketFilter = {
  branchIds: [],
  ticketTypeIds: [],
  ticketStatuses: [],
  startDate: null,
  endDate: null,
}

export interface IFilterState {
  ticketFilter: Object
}

export const initialState: IFilterState = {
  ticketFilter: initialTicketFilter,
}

const filterSlice = createSlice({
  name: 'filterSlice',
  initialState,
  reducers: {
    setFilter: (state: any, action) => {
      state[action.payload.name] = action.payload.data
    },
    clearFilter: (state: any, action) => {
      state[action.payload.name] = initialTicketFilter
    },
  },
})

const { actions, reducer } = filterSlice
export const { setFilter, clearFilter } = actions

export default reducer
